export default __webpack_public_path__ + "static/media/downloadCSV.37ab7a1d.jpg";